import { styled } from "@mui/material"

export const StyledButtonWrapper = styled("div")`
  display: flex;
`
export const StyledListWrapper = styled("div")`
  margin-top: 35px;
`
